'use client';
import CategoryGrid, { GridType } from '@components/shared/CategoryGrid';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import axios from 'axios';
import CategoryBody from '@components/shared/CategoryBody';
import PlaylistContext from './_PlaylistContext';
import GridItem from './_GridItem';

const TraegerTVCategoryBody = (props) => {
  const { body, showBreadcrumb, breadcrumb, category, _data } = props;
  const { locale } = useCurrentUrl();

  const loadData = async ({ page }, controller) => {
    return await axios.get('/api/traeger-tv/getTraegerTvListItems', {
      params: {
        category,
        page,
        pageSize: 10,
        lang: locale,
      },
      signal: controller.signal,
    });
  };

  return (
    <>
      <CategoryBody breadcrumb={breadcrumb} showBreadcrumb={showBreadcrumb} body={body}>
        <PlaylistContext.Provider value={_data.hits}>
          <CategoryGrid
            _data={_data}
            loadData={loadData}
            GridItemComponent={GridItem}
            type={GridType.TraegerTv}
            gridCardOverrides={{ xs: 12 }}
            darkBackground
            disableBorder
          />
        </PlaylistContext.Provider>
      </CategoryBody>
    </>
  );
};

export default TraegerTVCategoryBody;
